// permanent
export const FEATURE_PUBLIC_VIEW_SITE_IMPACT =
  'feature-public-view-site-impact';
// permanent
export const FEATURE_SITE_IMPACT_KPI_ALERTS = 'site-impact-kpi-alerts';

export const FEATURE_CONFIGURE_QUEUEING_SITE_IMPACT =
  'configure-queueing-site-impact';
export const TEMP_WORK_SHIFT_MAP_ICONS = 'temp-work-shift-map-icons';
export const FEATURE_COUNT_OVER_TIME = 'feature-count-over-time';
export const FEATURE_VIEW_COUNT_PROFILE = 'feature-view-count-profile';
export const FEATURE_PROGRAMME_ACCESS = 'feature-programme-management-access';
export const FEATURE_BUS_PERFORMANCE = 'feature-bus-performance';
export const FEATURE_SITE_KPI_ALERTS = 'feature-site-kpi-alerts';
export const FEATURE_CONFIG_DATA_SOURCES = 'feature-config-data-sources';
export const FEATURE_MANAGE_CONTRACTORS = 'feature-manage-contractors';
export const FEATURE_PROFILE_EDITING = 'feature-profile-editing';
export const FEATURE_WEATHER_PANEL = 'feature-weather-panel';
export const FEATURE_MANAGEMENT_SCHEDULING = 'feature-management-scheduling';
